import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';

import buildHref from '../utils/buildHref';

const GoodPractices = () => {
  const data = useStaticQuery(graphql`
    query {
      allGoogleSpreadsheetGoodPracticesInNanotechnologyManagement {
        edges {
          node {
            sections
            practices
            case1
            caseLink1
            case2
            caseLink2
            case3
            caseLink3
          }
        }
      }
    }
  `);

  const gsheet = data.allGoogleSpreadsheetGoodPracticesInNanotechnologyManagement.edges;
  const [ groupedData, setGroupedData ] = useState({});

  useEffect(() => {
    const results = {};

    gsheet.forEach(element => {
      Object.keys(element.node).filter(field => field === 'sections').forEach(item => {
        if (!results[element.node[item]]) {
          results[element.node[item]] = [];
        }
        results[element.node[item]].push(element.node);
      });
    });
    setGroupedData(results);
  }, [ gsheet ]);

  return (
    <Layout>
      <SEO title="Good practices in nanotechnology management" />
      <h1>Good practices in nanotechnology management</h1>

      <div className="practice__wrapper">
        { Object.keys(groupedData).map(section => (
          <div key={ `wrapper-${section}` } className="practice">
            <h2>{ section }</h2>
            { groupedData[section].map((content, idx) => (
              <div key={ `content-${idx * 1}` }>
                <p>{ content.practices }</p>
                <a href={ buildHref(content.caseLink1) } rel="noopener noreferrer" target="_blank">{ content.case1 }</a>
                <a href={ buildHref(content.caseLink2) } rel="noopener noreferrer" target="_blank">{ content.case2 }</a>
                <a href={ buildHref(content.caseLink2) } rel="noopener noreferrer" target="_blank">{ content.case3 }</a>
              </div>
            )) }
          </div>
        )) }
      </div>
    </Layout>
  );
};

export default GoodPractices;
